import {AppComponent} from './app.component';
import {PublisherComponent} from './visio/publisher/publisher.component';
import {SubscriberComponent} from './visio/subscriber/subscriber.component';
import {CaptureComponent} from './capture/capture.component';
import {SigninComponent} from './auth/signin/signin.component';
import {DossierComponent} from './dossier/dossier.component';
import {VisioComponent} from './visio/visio.component';
import {PopinComponent} from './popin/popin.component';
import {CguComponent} from './auth/cgu/cgu.component';
import {AutologComponent} from './autolog/autolog.component';
import {PhotoComponent} from './photo/photo.component';
import {PopinPhotoComponent} from './photo/popin-photo/popin-photo.component';

export const DECLARATIONS = [
  AppComponent,
  PublisherComponent,
  SubscriberComponent,
  CaptureComponent,
  SigninComponent,
  DossierComponent,
  VisioComponent,
  PopinComponent,
  CguComponent,
  AutologComponent,
  PhotoComponent,
  PopinPhotoComponent
];




// WEBPACK FOOTER //
// ./src/app/app.module.declarations.ts